import { Component, OnInit, inject } from '@angular/core';
import { PagesService } from '../pages.service';
import { MenuItem } from '../producers/interfaces';
import { Router, RouterOutlet } from '@angular/router';
import {ProductTagsAndNavigationComponent} from "./product-tags-and-navigation/product-tags-and-navigation.component";

@Component({
    selector: 'app-how-it-works',
    imports: [RouterOutlet],
    templateUrl: './how-it-works.component.html',
    styleUrl: './how-it-works.component.scss'
})
export class HowItWorksComponent implements OnInit {
  pagesService = inject(PagesService);

  ngOnInit(): void {
    this.setUpMenu();
  }

  private setUpMenu() {
    const sideMenu: MenuItem[] = [
      {
        active: true,
        link: 'how-it-works/main',
        title: 'How it Works'
      },
      {
        active: false,
        link: 'how-it-works/product-tags-and-navigation',
        title: 'Product Tags and Navigation'
      },
      {
        active: false,
        link: 'how-it-works/rewards-program',
        title: 'Roots Rewards Program'
      },
      {
        active: false,
        link: 'how-it-works/produce-program',
        title: 'Low Cost Produce Program'
      },
    ];
    this.pagesService.setSideMenu(sideMenu);
  }
}
